import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const StyledSlidingTopContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const StyledLogoContainer = styled(Flex)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: theme.spacing(16),
  alignSelf: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary[700],
  marginRight: theme.spacing(12),
}));

export const StyledLogo = styled('img')(({ theme }) => ({
  width: 28,
  height: 28,
  objectFit: 'contain',
}));
